import { render, staticRenderFns } from "./TicketEscalateDialog.vue?vue&type=template&id=79b4fa62&"
import script from "./TicketEscalateDialog.vue?vue&type=script&lang=ts&"
export * from "./TicketEscalateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports